/**
 * function allows to define if there is an intersection between two rectangles
 * @param x1 - left top x coordinates of first point
 * @param y1- left top y coordinates of first point
 * @param w1- widths of first point
 * @param h1 - heights of first point
 * @param x2 - left top x coordinates of second point
 * @param y2 - left top y coordinates of second point
 * @param w2 - widths of second point
 * @param h2 - heights of second point
 */
export const checkIntersectionOfTwoRectangles = (
	x1: number,
	y1: number,
	w1: number,
	h1: number,
	x2: number,
	y2: number,
	w2: number,
	h2: number,
): boolean =>
	Math.max(x1, x2) < Math.min(x1 + w1, x2 + w2) &&
	Math.max(y1, y2) < Math.min(y1 + h1, y2 + h2);
